<template>
  <div class="container is-max-desktop">
    <Header
      @connect="onConnect"
      @disconnect="resetApp"
    />
    <div
      id="main"
      class="columns is-centered"
    >
      <div class="column">
        <div class="box">
          <router-view v-if="connected" />


          <div v-else class="wrapper">

            <div class="left-col">
              <p  class="connection-message custom-box">
                <span class="icon has-text-info">
                 <i class="fas fa-info-circle"></i>
                </span>
                <!-- <span class="icon has-text-warning">
                 <i class="fas fa-exclamation-triangle"></i>
                </span> -->
                  Please connect your wallet again.. 👆
              </p>
              
               
               <!-- <br> -->

                <!-- <h1>Quality apparel without the price tag</h1>
                <p class="subheading">No need to spend $xxx on apparel just for the name’s sake. 
                    Our premium apparel is made from the same stuff.</p> -->
                
                <div class="btn2 center">
                    <a class="btn-1" href="https://wizard-bridge-evm.gitbook.io/docs/product-guides/getting-use-up" target="_blank">
                      How To Bridge</a>

                    <a class="btn-2" href="https://wizard-bridge-evm.gitbook.io/docs/overview/what-we-do" target="_blank">
                        <span>What is Wizard Bridge EVM? </span>
                        <svg viewBox="0 0 19 8" fill="none">
                            <path d="M18.3536 4.35355C18.5488 4.15829 18.5488 3.84171 18.3536 3.64645L15.1716 0.464466C14.9763 0.269204 14.6597 0.269204 14.4645 0.464466C14.2692 0.659728 14.2692 0.976311 14.4645 1.17157L17.2929 4L14.4645 6.82843C14.2692 7.02369 14.2692 7.34027 14.4645 7.53553C14.6597 7.7308 14.9763 7.7308 15.1716 7.53553L18.3536 4.35355ZM0 4.5H18V3.5H0V4.5Z" fill="black"/>
                        </svg> 
                    </a>   

                </div>
                
                <!-- <div class="news container"> -->
                  <div class="">
                    <!-- <p class="employees">50K</p> -->
                    <p class="text-anime">
                      Better Solutions For 
                        <strong>Bridge</strong>. 
                    </p>
                </div>

                <br>

            </div>
       
            <div class=""> 
                
                    <div class="card1">
                            <div class="card-details"> 
                                <div>
                                     <a href="https://wizard-bridge-evm.gitbook.io/docs/product-guides/get-faucets" target="_blank" class="product-title">
                                      Test token in Bridge </a>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                                   <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/>
                                   <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/>
                                  </svg>
                                    <h3>Get Faucets</h3>
                                </div>
                                <p class="product-price"></p>
                            </div>
                    </div>

                    <br>

                    <div class="card2">
                        <div class="card-details"> 
                            <div>
                                 <a href="https://wizard-bridge-evm.gitbook.io/docs/fundamentals/wizard-bridge-evm-erc-20" target="_blank" class="product-title">
                                  Fact Protocol Interface </a>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                                   <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/>
                                   <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/>
                                  </svg>
                                <h3>Proof of Message</h3>
                            </div>
                            <p class="product-price"></p>
                        </div>
                    </div>

                    <br>

                    <div class="card3">
                        <div class="card-details"> 
                            <div>
                                 <a href="https://wizard-bridge-evm.gitbook.io/docs/product-guides/faqs" target="_blank" class="product-title">
                                  FAQs </a>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                                   <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/>
                                   <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/>
                                  </svg>
                                 <h3>More information</h3>
                            </div>
                            <p class="product-price"></p>
                        </div>
                    </div>
                    

            </div>
      
    </div>
          


        </div>

        <!-- <div class="container is-max-desktop">
          <div class="box">
            <img src="img/Wizard Bridge EVM-Cover.png" alt="">
        </div>
        </div> -->
        
      </div>
      
    </div>
    <Footer />
  </div>

  <!-- Loader modal -->
  <div
    v-if="fetching"
    class="modal is-active is-loader"
  >
    <div
      class="modal-background"
    />
    <div class="modal-content">
      <div class="section">
        <div class="container">
          <div class="columns">
            <div class="column is-6 is-offset-3">
              <div class="box">
                <div class="loader-wrapper is-active">
                  <div class="loader is-loading" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Web3Modal from 'web3modal'
import { Web3Provider } from '@ethersproject/providers'
import WalletConnectProvider from '@walletconnect/web3-provider'
import { markRaw } from '@vue/reactivity'
import { mapState } from 'vuex'

import Header from '@/components/Header'
import Footer from '@/components/Footer'
import utilities from '@/mixins/utilities'
import { getChainData } from '@/constants/chains'

export default {
  components: {
    Header,
    Footer
  },
  mixins: [
    utilities
  ],
  data () {
    return {
      providerOptions: {
        walletconnect: {
          package: WalletConnectProvider,
          options: {
            infuraId: process.env.VUE_APP_INFURA_ID
          }
        }
      },
      web3Modal: null
    }
  },
  computed: mapState([
    'connected',
    'fetching'
  ]),
  mounted () {
    this.web3Modal = new Web3Modal({
      network: this.getNetwork(),
      cacheProvider: true,
      providerOptions: this.providerOptions
    })

    // window.localStorage.setItem('tokens', JSON.stringify([]))
  },
  methods: {
    async onConnect () {
      let provider
      try {
        provider = markRaw(await this.web3Modal.connect())
      } catch (err) {
        // this.errorToast(err)
        return
      }

      const library = markRaw(new Web3Provider(provider))
      const network = markRaw(await library.getNetwork())
      const account = provider.selectedAddress ? provider.selectedAddress : provider.accounts[0]

      this.$store.commit('updateProvider', provider)
      this.$store.commit('updateLibrary', library)
      this.$store.commit('updateAccount', account)
      this.$store.commit('updateChainId', network.chainId)
      this.$store.commit('updateConnected', true)

      await this.subscribeToProviderEvents()
      this.$router.push({ name: 'bridge' })
    },
    async subscribeToProviderEvents () {
      const provider = this.$store.state.provider
      if (!provider.on) {
        return
      }

      provider.on('accountsChanged', this.changedAccount)
      provider.on('networkChanged', this.networkChanged)
      provider.on('close', this.close)
    },
    async unsubscribeFromProviderEvents () {
      // Workaround for metamask widget > 9.0.3 (provider.off is undefined)
      const provider = this.$store.state.provider
      window.location.reload(false)
      if (!provider.off) {
        return
      }

      provider.off('accountsChanged', this.changedAccount)
      provider.off('networkChanged', this.networkChanged)
      provider.off('close', this.close)
    },
    async changedAccount (accounts) {
      if (!accounts.length) {
        // Metamask Lock fire an empty accounts array
        await this.resetApp()
      } else {
        this.$store.commit('updateAccount', accounts[0])
      }
    },
    async networkChanged () {
      const library = markRaw(new Web3Provider(this.$store.state.provider))
      const network = markRaw(await library.getNetwork())

      this.$store.commit('updateLibrary', library)
      this.$store.commit('updateChainId', network.chainId)
    },
    async close () {
      this.resetApp()
    },
    getNetwork () {
      return getChainData(this.$store.state.chainId).network
    },
    async resetApp () {
      await this.web3Modal.clearCachedProvider()
      window.localStorage.removeItem('WEB3_CONNECT_CACHED_PROVIDER')
      window.localStorage.removeItem('walletconnect')
      await this.unsubscribeFromProviderEvents()
      this.$store.commit('resetStore')
    }
  }
}
</script>

<style>
#main {
  margin: 50px 0 50px 0;
}

.web3modal-modal-lightbox{
  z-index: 10000 !important;
}

</style>
